module.exports = __webpack_public_path__ + "static/media/icon-error.4199099a.svg";